import { useSyncExternalStore } from 'react';

type BaseInlineEditorModule = typeof import('./BaseInlineEditor');

let loadPromise: Promise<BaseInlineEditorModule> | null = null;
let isLoading = false;
const listeners = new Set<() => void>();

const notifyInlineEditorLoad = () => {
  for (const listener of listeners) {
    listener();
  }
};

export const subscribeInlineEditorLoad = (listener: () => void) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

export const getInlineEditorLoadSnapshot = () => isLoading;

export const loadBaseInlineEditor = (): Promise<BaseInlineEditorModule> => {
  if (!loadPromise) {
    isLoading = true;
    notifyInlineEditorLoad();
    loadPromise = import('./BaseInlineEditor').finally(() => {
      isLoading = false;
      notifyInlineEditorLoad();
    });
  }

  return loadPromise;
};

export const useIsInlineEditorLoading = () =>
  useSyncExternalStore(subscribeInlineEditorLoad, getInlineEditorLoadSnapshot, () => false);
